import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'System|Criteria|Rules|Criteria Rule Item|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRulesCriteriaRuleItem';
export type SPSystemCriteriaRulesCriteriaRuleItemLocNames =
	| `${LocNameStart}ContentNot`
	| `${LocNameStart}ContentRequired`
	| `${LocNameStart}ContentAll`;

export const spSystemCriteriaRulesCriteriaRuleItemLocs: LocDefs<SPSystemCriteriaRulesCriteriaRuleItemLocNames> =
	{
		SPSystemCriteriaRulesCriteriaRuleItemContentNot: {
			defaultValue: 'Not',
			description: 'Text shown for: Not.',
			displayPath: `${pathStart}Not`,
			displayType: 'Content',
			legacyName: 'Announcements/Tools.AnnouncementCriteria.Content.Not',
			...sharedProperties,
		},
		SPSystemCriteriaRulesCriteriaRuleItemContentRequired: {
			defaultValue: 'Required',
			description: 'Text shown for: Required.',
			displayPath: `${pathStart}Required`,
			displayType: 'Content',
			legacyName: 'Announcements/Tools.AnnouncementCriteria.Content.Required',
			...sharedProperties,
		},
		SPSystemCriteriaRulesCriteriaRuleItemContentAll: {
			defaultValue: 'All',
			description: 'Text shown for: All.',
			displayPath: `${pathStart}All`,
			displayType: 'Content',
			legacyName: 'Announcements/Tools.AnnouncementCriteria.Content.All',
			...sharedProperties,
		},
	};

export type SPSystemCriteriaRulesCriteriaRuleItemLocType =
	LocMap<SPSystemCriteriaRulesCriteriaRuleItemLocNames>;
